import { all, takeLatest } from "redux-saga/effects";
import { types as modalsAnchorActions } from "@/bit/reducers/next13.reducers.modals-reducer";
import { types as headerActions } from "@/bit/reducers/next13.reducers.header-reducer";
import { types as mainActions } from "@/bit/reducers/next13.reducers.main-reducer";
import { initAnchorModalListener, addModal } from "@/bit/sagas/next13.sagas.modals-saga";
import { getSearcherInfo, getRelatedPages } from "@/bit/sagas/next13.sagas.header-saga";
import { checkCPAndSetZones } from "@/bit/sagas/next13.sagas.main-saga";

function* rootSaga() {
  yield all([
    takeLatest(
      modalsAnchorActions.INIT_ANCHOR_MODAL_LISTENER,
      initAnchorModalListener
    ),
    takeLatest(modalsAnchorActions.ADD_MODAL, addModal),
    //searcher
    takeLatest(headerActions.GET_SEARCHER_INFO, getSearcherInfo),
    takeLatest(headerActions.GET_RELATED_PAGES, getRelatedPages),
    //cp
    takeLatest(mainActions.CHECK_CP_AND_SET_ZONES, checkCPAndSetZones),
  ]);
}

export default rootSaga;
